import { render, staticRenderFns } from "./IsDraftMessage.vue?vue&type=template&id=2d9e4409&"
import script from "./IsDraftMessage.vue?vue&type=script&lang=js&"
export * from "./IsDraftMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports